import Vehicle from '../Vehicle';
import Gateway from '../../Gateway';

export default class VehicleContextAdder {
  static add(data, snowplow) {
    try {
      const context = new Vehicle();
      context.importData(data);
      snowplow.globalContexts.add(context);
    } catch (e) {
      Gateway.window.console.warn(e.message);
    }
  }
};
